import SigliveServiceV2 from 'Service/sigliveServiceV2';

const patchNotifications = async (data) => {
  await SigliveServiceV2({ method: 'PATCH', url: `/notification/mark-all-as-read`, data });
};

export default patchNotifications;
